export enum SkeletonThemeType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
